import { render } from "./InsertPosition.vue?vue&type=template&id=e03e3c58"
import script from "./InsertPosition.vue?vue&type=script&lang=js"
export * from "./InsertPosition.vue?vue&type=script&lang=js"
script.render = render

export default script